<template>
    <div class="main">
        <el-table
            :data="tableData"
            border
            style="width: 100%; margin-top: 20px"
            :header-cell-style="{ background: '#f2f2f2', color: '#000' }"
        >
            <el-table-column
                type="index"
                width="70"
                label="序号"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>

            <el-table-column
                prop="eventType"
                label="事件类型"
                align="center"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.eventType == 0">健康预警</span>
                    <span v-if="scope.row.eventType == 1">健康预警</span>
                </template>
            </el-table-column>
            <el-table-column
                prop="alarmTime"
                label="告警时间"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="alarmContent"
                label="告警内容"
                align="center"
                :show-overflow-tooltip="true"
            >
            </el-table-column>
            <el-table-column
                prop="processingStatus"
                label="状态"
                align="center"
                :show-overflow-tooltip="true"
            >
                <template slot-scope="scope">
                    <span v-if="scope.row.processingStatus == 0">未处理</span>
                    <span v-if="scope.row.processingStatus == 1">已处理</span>
                </template>
            </el-table-column>
        </el-table>
        <el-pagination
            class="pages"
            background
            layout="total, prev, pager, next"
            @current-change="handleCurrentChange"
            :total="page.total"
            :current-page.sync="page.pageNo"
            :page-size="10"
        >
        </el-pagination>
    </div>
</template>

<script>
import request from "@/utils/request.js"
import exportVue from "@/utils/exportVue"
export default {
    props: {
        setTitle: {
            type: String,
            default: "",
        },
    },
    data() {
        return {
            tableData: [],
            waingId: "",
            page: { pageSize: 10, pageNo: 1, total: 0 },
        }
    },
    created() {
        if (this.setTitle != "新增") {
            exportVue.$on("warningId", (data) => {
                this.waingId = data
                this.getList()
            })
        }
    },
    methods: {
        // 分页
        handleCurrentChange(val) {
            this.page.pageNo = val
            this.getList()
        },
        // 获取选中
        getList() {
            let params = {
                pageNo: this.page.pageNo,
                pageSize: this.page.pageSize,
                yptCustomerId: this.waingId,
            }
            this.$http
                .request({
                    url: "/ypt/admin/customerHealthWarn/info/findList",
                    method: "POST",
                    data: params,
                })
                .then((res) => {
                    if (res.code == 200) {
                        if (res.content == null || res.content == "null") {
                            this.tableData = []
                            this.page.total = 0
                            return
                        }
                        this.tableData = res.content.list
                        this.page.total = res.content.count
                    }
                })
        },
    },
}
</script>

<style lang="less" scoped>
.pages {
    margin-top: 20px;
}
</style>
